import Bugsnag from "@bugsnag/js";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import SEO from "react-seo-component";
import Login from "../../components/Login";
import util from "../../util";
import ProfileMenuHeader from "../customer-profile/ProfileMenuHeader";

import cookie from "react-cookies";
import {
  Button,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import PlacesAutocomplete from "../../components/common/PlacesAutocomplete";
import constants from "../../Constants";

const baseURL = constants.baseURL;
class Section extends Component {
  constructor() {
    super();

    this.state = {
      loading: false,
      success: false,
      openSuccessModal: false,
      trucktype: "1.5tonopen",
      apierror: "",
      startdate: "",
      enddate: "",
      vehiclecount: 1,
      storage: { homelat: 0, homelng: 0 },
      delivery: { homelat: 0, homelng: 0 },
      description: "",
      vehicletypes: [],
      sellingprice: 0,
    };
  }

  getVehicleTypes() {
    const { vehicletypes } = this.state;
    if (vehicletypes?.length === 0)
      axios.get(baseURL + "/contract-vehicle-hire-types").then((repos) => {
        const vehicletypesdata = repos.data;
        this.setState({
          vehicletypes: vehicletypesdata?.vehicles,
          vehiclecategories: vehicletypesdata?.categories,
          vehicleconfigurations: vehicletypesdata?.configurations,
        });
      });
  }
  calcSellingPrice(startdate, enddate, trucktype, vehiclecount) {
    const { vehicletypes } = this.state;
    let a = moment(startdate);
    let b = moment(enddate);
    console.log(a);
    console.log(b);
    const days = b.diff(a, "days") + 1;
    let rate = "daily";
    let rater = 1;
    if (days > 6 && days <= 27) {
      rate = "weekly";
      rater = 7;
    }
    if (days > 27) {
      rate = "monthly";
      rater = 28;
    }

    console.log(days);
    console.log(rate);

    const quotedistance = vehicletypes?.find((v) => v.type === trucktype)[
      rate + "distance"
    ];
    this.setState({
      quotedistance: Math.ceil(quotedistance / rater) * days * vehiclecount,
    });
    return (
      vehiclecount *
      days *
      (vehicletypes.find((v) => v.type === trucktype)
        ? vehicletypes.find((v) => v.type === trucktype)[rate + "rate"] / rater
        : 0)
    );
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextState.startdate !== this.state.startdate ||
      nextState.enddate !== this.state.enddate ||
      nextState.vehiclecount !== this.state.vehiclecount ||
      nextState.trucktype !== this.state.trucktype
    ) {
      const sellingprice = this.calcSellingPrice(
        nextState.startdate,
        nextState.enddate,
        nextState.trucktype,
        nextState.vehiclecount
      );
      this.setState({ sellingprice }, () => {
        if (sellingprice > 0) this.submitQuote();
      });
    }
    return true;
  }

  changeTruck() {
    window.document.getElementById("categoriesbelow").scrollIntoView();
  }

  validStepTwo() {
    const {
      trucktype,
      startdate,
      enddate,
      vehiclecount,
      storage,
      delivery,
      description,
      sellingprice,
    } = this.state;

    try {
      return (
        trucktype?.length > 0 &&
        startdate.length > 0 &&
        enddate.length > 0 &&
        vehiclecount > 0 &&
        parseFloat(sellingprice) > 0 &&
        storage.homelat !== 0 &&
        storage.homelng !== 0 &&
        delivery.homelng !== 0 &&
        delivery.homelng !== 0 &&
        description?.length > 0
      );
    } catch (error) {
      return false;
    }
  }
  componentDidMount() {
    if (cookie.load("qtcid_")) this.getCustomerProfile();
  }
  getCustomerProfile() {
    axios
      .get(baseURL + "/customer-profile", {
        headers: {
          "Content-Type": "application/json",
          Authorization: cookie.load("qtcid_"),
        },
      })
      .then((response) => {
        this.setState({
          profile: response.data,
        });
      })
      .catch((e) => {
        this.setState({ apierror: e.message });
        Bugsnag.notify(e);
      })
      .finally(() => this.setState({ loading: false }));
  }
  submitQuote() {
    const {
      trucktype,
      startdate,
      enddate,
      vehiclecount,
      delivery,
      storage,
      description,
      sellingprice,
      profile,
    } = this.state;

    axios
      .post(baseURL + "/customer-create-contract-quote", {
        trucktype,
        startdate,
        enddate,
        vehiclecount,
        delivery,
        storage,
        description,
        sellingprice,
        customerid: profile?.customerid,
        source_:
          util.navigator_() + util.source_() + " qtref:" + document?.referrer,
      })
      .catch((e) => {});
  }
  createContract() {
    this.setState({
      loading: true,
      apierror: "",
    });
    const {
      trucktype,
      startdate,
      enddate,
      vehiclecount,
      delivery,
      storage,
      description,
      sellingprice,
      profile,
    } = this.state;

    axios
      .post(
        baseURL + "/customer-create-contract",
        {
          trucktype,
          startdate,
          enddate,
          vehiclecount,
          storage,
          delivery,
          description,
          sellingprice,
          customerid: profile?.customerid,
          source_:
            util.navigator_() + util.source_() + " qtref:" + document?.referrer,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: cookie.load("qtcid_"),
          },
        }
      )
      .then((response) => {
        this.setState({
          loading: false,
          success: response.status === 200,
          openSuccessModal: true,
        });
      })
      .catch((e) => {
        this.setState({
          loading: false,
          apierror: "Request failed. Please try again.",
        });
      });
  }

  getImage(trucktype) {
    try {
      return `https://media.qiktruck.co.za/${trucktype}.png`;
    } catch (error) {
      return "";
    }
  }

  render() {
    this.getVehicleTypes();
    const { vehicletypes, sellingprice } = this.state;
    return (
      <React.Fragment>
        {!cookie.load("qtcid_") && <Login />}
        <div id={"pagefragmenttop"}></div>
        <SEO
          title={"Hire a truck for your deliveries Today"}
          titleTemplate={"QikTruck"}
          titleSeparator={`-`}
          description={
            "Online quotation today for hire a truck with a diver to transport your goods."
          }
          image={"https://media.qiktruck.co.za/qiktruck-preview-header.png"}
          pathname={"https://qiktruck.co.za/truck-hire"}
          twitterUsername={"qiktrucksa"}
        />
        <section className="hero-section" id={"pagetop"}>
          <Modal isOpen={this.state.success && this.state.openSuccessModal}>
            <ModalHeader>
              <i className={"mdi mdi-check-circle  order-received"}></i>
              Request Received
            </ModalHeader>
            <ModalBody>
              <ListGroup className="black-text">
                <ListGroupItem>
                  <i className={"mdi mdi-check-circle order-received-list"}></i>
                  Our team will be in touch shortly to confirm your order.
                </ListGroupItem>
                <ListGroupItem>
                  <i className={"mdi mdi-check-circle order-received-list"}></i>
                  Happy moving!
                </ListGroupItem>
              </ListGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="primary">
                <a href="/customer-truck-hire-contracts">Okay</a>
              </Button>
            </ModalFooter>
          </Modal>

          <Container>
            <div className="store-front">
              <Row>
                <Col lg={12}>
                  <div className="hero-wrapper mb-4">
                    <ProfileMenuHeader
                      heading={"Book a regular driver and vehicle"}
                      image=""
                    />
                    <Row>
                      <Col lg={6} md={6} className="truck-hire">
                        <p color="orange">
                          <i className="mdi mdi-star"></i>For customers to book
                          regular trips.
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>All vehicles come with
                          a driver.
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>Free driver app for
                          managing trips.
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>24/7 customer support.
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>GPS tracking -
                          ensuring that drivers always reach their destination
                          on time.
                        </p>
                      </Col>
                      <Col lg={6} md={6} className="truck-hire">
                        <p>
                          <i className="mdi mdi-star"></i>Insurance of up to
                          R500 000+
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>Free delivery SMS and
                          Email notifications.
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>Regular maintenance for vehicles.
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>Fuel costs are
                          covered on all trips.
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>3 other vehicles on
                          standby.
                        </p>
                      </Col>
                      <Col lg={6} md={6} className="truck-hire">
                        <p>
                          <i className="mdi mdi-star"></i>Roadside assistance -
                          providing peace of mind in case of breakdowns or
                          accidents.
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>Flexible rental
                          options - hourly, daily, weekly, and monthly rental
                          options to accommodate different customer needs.
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>Special offers and
                          discounts - to incentivize repeat business.
                        </p>
                      </Col>
                      <Col lg={12} md={12}>
                        <br />
                        <h3
                          className={"category-below "}
                          id="categoriesbelow"
                          onClick={() => this.changeTruck()}
                        >
                          Select a vehicle{" "}
                        </h3>
                        <p>
                          All <a href="/terms">terms and conditions</a> apply.
                        </p>
                      </Col>

                      {vehicletypes
                        ?.filter((v) => v.businesshire === true && v.sell)
                        ?.map((vehicle) => {
                          const image = this.getImage(vehicle.type);
                          return (
                            <Col
                              key={vehicle.type}
                              lg={2}
                              md={3}
                              sm={12}
                              xs={12}
                              xl={2}
                              className={"grey-border-bottom vehicle-type"}
                              onClick={() =>
                                this.setState(
                                  {
                                    trucktype: vehicle.type,
                                  },
                                  () => {
                                    window.document
                                      .getElementById("hireoptions")
                                      .scrollIntoView();
                                  }
                                )
                              }
                            >
                              <div
                                className={
                                  this.state.trucktype === vehicle.type
                                    ? "selected-truck"
                                    : ""
                                }
                              ></div>
                              <img
                                src={image}
                                alt=""
                                className={
                                  "menu-truck " +
                                  (this.state.trucktype === vehicle.type
                                    ? "menu-truck-selected"
                                    : "")
                                }
                                height="20"
                              />
                              <i
                                className={
                                  "mdi mdi-check-circle ml-2 " +
                                  (this.state.trucktype === vehicle.type
                                    ? "checked-truck"
                                    : "hide")
                                }
                              ></i>
                              <p className="menu-truck-tip " id={vehicle.type}>
                                <span className="menu-truck-tonnes">
                                  {vehicle.tonnes} Ton
                                </span>
                                {vehicle.tip.shortform}
                                >>{vehicle.type}
                                {/* <div className={"vehicle-type-rate "}>
                                  <div className="hire-price-rate">
                                    daily rate
                                    <CurrencyFormat
                                      value={vehicle.dailyrate / 100}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      prefix={"R"}
                                      decimalScale={2}
                                    />
                                    <br />
                                  </div>
                                  <div className="hire-price-rate">
                                    weekly
                                    <CurrencyFormat
                                      value={vehicle.weeklyrate / 100}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      prefix={"R"}
                                      decimalScale={2}
                                    />
                                    <br />
                                  </div>
                                  <div className="hire-price-rate">
                                    monthly
                                    <CurrencyFormat
                                      value={vehicle.monthlyrate / 100}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      prefix={"R"}
                                      decimalScale={2}
                                    />
                                    <br />
                                  </div>
                                </div> */}
                              </p>
                            </Col>
                          );
                        })}
                    </Row>
                    <p id="hireoptions"></p>
                    <h3>Quotation details</h3>
                    <p>
                      We use this information to calculate the best price for
                      your dates and delivery area.
                    </p>
                    <Row>
                      <Col lg={6} md={6} sm={12}>
                        <FormGroup>
                          <Label for="startdate">
                            Start date <span>*</span>
                          </Label>
                          <Input
                            id="startdate"
                            name="startdate"
                            placeholder="Start date"
                            type="date"
                            onChange={(e) => {
                              this.setState({ startdate: e.target.value });
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6} md={6} sm={12}>
                        <FormGroup>
                          <Label for="enddate">
                            End date <span>*</span>
                          </Label>
                          <Input
                            id="enddate"
                            name="enddate"
                            placeholder="Enddate date"
                            type="date"
                            onChange={(e) => {
                              this.setState({ enddate: e.target.value });
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg={6} sm={12}>
                        <FormGroup autoComplete="new-password">
                          <Label for="delivery">
                            {" "}
                            Goods Collection area <span>*</span>
                          </Label>
                          <PlacesAutocomplete
                            type="text"
                            className="form-control"
                            id="storage"
                            placeholder="Town, City, Province or Address"
                            required
                            autoComplete="new-password"
                            onPlaceSelected={(place) => {
                              console.log(place);
                              if (!place?.geometry?.location?.lat()) {
                                Bugsnag.notify(
                                  new Error(
                                    "COLLECTION place not found: " +
                                      this.state.trucktype
                                  )
                                );
                              }
                              this.setState(
                                {
                                  storage: {
                                    homelat: place?.geometry?.location?.lat(),
                                    homelng: place?.geometry?.location?.lng(),
                                  },
                                },
                                () =>
                                  console.log({
                                    homelat: place?.geometry?.location?.lat(),
                                    homelng: place?.geometry?.location?.lng(),
                                  })
                              );
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6} sm={12}>
                        <FormGroup autoComplete="new-password">
                          <Label for="delivery">
                            {" "}
                            Goods Delivery area <span>*</span>
                          </Label>
                          <PlacesAutocomplete
                            type="text"
                            className="form-control"
                            id="delivery"
                            placeholder="Town, City, Province or Address"
                            required
                            autoComplete="new-password"
                            onPlaceSelected={(place) => {
                              console.log(place);
                              if (!place?.geometry?.location?.lat()) {
                                Bugsnag.notify(
                                  new Error(
                                    "COLLECTION place not found: " +
                                      this.state.trucktype
                                  )
                                );
                              }
                              this.setState(
                                {
                                  delivery: {
                                    homelat: place?.geometry?.location?.lat(),
                                    homelng: place?.geometry?.location?.lng(),
                                  },
                                },
                                () =>
                                  console.log({
                                    homelat: place?.geometry?.location?.lat(),
                                    homelng: place?.geometry?.location?.lng(),
                                  })
                              );
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6} md={6} sm={12}>
                        <FormGroup>
                          <Label for="enddate">
                            Number of vehicles <span>*</span>
                          </Label>
                          <Input
                            id="vehiclecount"
                            name="vehiclecount"
                            type="number"
                            min={1}
                            defaultValue={1}
                            onChange={(e) => {
                              this.setState({ vehiclecount: e.target.value });
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={12} sm={12}>
                        <FormGroup>
                          <Label for="description">
                            Instructions <span>*</span>
                          </Label>
                          <Input
                            id="description"
                            name="text"
                            type="textarea"
                            defaultValue={this.state.description}
                            style={{ minHeight: 120 }}
                            placeholder="Any extra information about this request..."
                            onChange={(e) => {
                              this.setState({ description: e.target.value });
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6} sm={12}>
                        <FormGroup>
                          <div
                            className="hire-button-truck"
                            onClick={() => {
                              this.changeTruck();
                            }}
                          >
                            <img
                              src={this.getImage(this.state.trucktype)}
                              alt=""
                            />
                            <br />
                            {this.state.trucktype
                              ? "Change vehicle >"
                              : "No vehicle selected >"}
                          </div>
                          <br />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        lg={4}
                        md={4}
                        sm={12}
                        className={
                          "hireprice " + (sellingprice ? "active" : "")
                        }
                      >
                        {/* {sellingprice > 0 && (
                          <CurrencyFormat
                            value={Math.ceil(sellingprice / 100)} //cents to rands
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"R "}
                            decimalScale={2}
                          />
                        )} */}
                        {/* <span
                          className={
                            "dayx " +
                            (moment(startdate) < moment(enddate)
                              ? "good"
                              : startdate.length > 0 && startdate !== enddate
                              ? "bad"
                              : "")
                          }
                        >
                          For{" "}
                          {(() => {
                            if (startdate === enddate) return 1;
                            let a = moment(startdate);
                            let b = moment(enddate);
                            const days = b.diff(a, "days") + 1;
                            return days;
                          })()}{" "}
                          day(s), {vehiclecount} vehicle(s).
                          <br />
                          Total {quotedistance}km
                        </span> */}
                      </Col>
                      <Col lg={12} md={12}>
                        <p>
                          <hr />
                          <i className="mdi mdi-star"></i>Vehicles come with a
                          driver and free driver app.{" "}
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>3 other vehicles on
                          standby.
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>Fuel costs are covered
                          in the price.
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>Vehicle tracking
                          everywhere.
                          <i className="mdi mdi-star"></i>Insurance of up to
                          R500 000+
                        </p>
                        <p>
                          <i className="mdi mdi-star"></i>Regular maintenance.
                          <i className="mdi mdi-star"></i>Free delivery SMS and
                          Email notifications.
                        </p>
                      </Col>
                    </Row>
                    <div
                      style={{
                        width: "100%",
                        display: "block",
                        float: "left",
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      <Button
                        className="float-right mb-4"
                        color="primary"
                        onClick={() => {
                          this.createContract();
                        }}
                        style={{ width: "fit-content", marginTop: "20px" }}
                        disabled={!this.validStepTwo() || this.state.loading}
                      >
                        Submit Booking
                        <i className="mdi mdi-arrow-right-bold ml-2"></i>
                      </Button>
                    </div>

                    {this.state.loading === false &&
                      this.state.apierror.length > 0 && (
                        <p className="error-message">{this.state.apierror}</p>
                      )}
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
